<template>
  <div class="demand-history-container">
    <el-table :data="historyList" class="table-container" v-loading="loading">
      <el-table-column prop="uuid" :label="$str.getKey('策略控制/设备标识')" min-width="120" />
      <el-table-column prop="groupIndex" :label="$str.getKey('策略控制/分组索引')" min-width="100" />
      <el-table-column prop="demandMax" :label="$str.getKey('策略控制/需量(kW)')" min-width="120" >
      </el-table-column>
      <el-table-column :label="$str.getKey('策略控制/需量详情')" min-width="120">
        <template #default="scope">
          <el-tooltip effect="light" placement="top">
            <template #content>
              <div style="white-space: pre-line; min-width: 120px;" v-html="getDemandDetailHtml(scope.row)"></div>
            </template>
            <el-button type="text" size="small">{{ $str.getKey('策略控制/详情') }}</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" :label="$str.getKey('策略控制/更新时间')" min-width="180">
        <template #default="scope">
          {{ formatTime(scope.row.updateTime) }}
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <div class="pagination-container" v-if="total >= 0">
      <el-pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch,computed } from 'vue'
import dayjs from 'dayjs'
import * as strategyApi from '../api.js'
const $str = window.$str;

const props = defineProps({
  stationId: {
    type: [String, Number],
    required: true
  },
  uuid:{
     type: [String, Number],
    required: true
  }
})

const loading = ref(false)
const historyList = ref([])
const total = ref(0)
const currentPage = ref(1)
const pageSize = ref(20)

// 格式化时间
function formatTime(time) {
  if (!time) return '--'
  return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
}

// 新增：格式化需量详情内容（HTML版，支持换行）
function getDemandDetailHtml(row) {
  let html = `<div>${$str.getKey('策略控制/动态需量预留值')}: ${row.protectiveValue ?? '--'}</div>`;
  html += `<div>${$str.getKey('策略控制/动态需量起始值')}：</div>`;
  let monthlyArr = [];
  if (Array.isArray(row.monthly)) {
    monthlyArr = row.monthly;
  } else if (typeof row.monthly === 'string') {
    try {
      const parsed = JSON.parse(row.monthly);
      if (Array.isArray(parsed)) {
        monthlyArr = parsed;
      } else if (typeof parsed === 'object') {
        for (let i = 1; i <= 12; i++) {
          monthlyArr.push(Number(parsed[i] || 0));
        }
      }
    } catch {
      monthlyArr = [];
    }
  }
  for (let i = 0; i < 12; i++) {
    html += `<div>${isZh.value ? i+1+' '+$str.getKey('策略控制/月') : getMonthEn(i)}: ${monthlyArr[i] ?? '--'}</div>`;
  }
  return html;
}
const isZh = computed(() => localStorage.getItem('language') == 'cn')
function getMonthEn(index){
  const monthEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return monthEn[index]
}

// 获取需量历史数据
async function loadDemandHistory() {
  if (!props.stationId) return
  
  loading.value = true
  try {
    const res = await strategyApi.getStationConfigReceiveRecord({
      stationId: props.stationId,
      pageNum: currentPage.value,
      pageSize: pageSize.value,
      uuid: props.uuid
    })
     console.error('需量:', res)
    if (res.code == 200) {
      historyList.value = res.rows
      total.value = res.total || 0
    }
  } catch (error) {
    console.error('获取需量历史失败:', error)
    historyList.value = []
    total.value = 0
  } finally {
    loading.value = false
  }
}

// 分页大小改变
function handleSizeChange(size) {
  pageSize.value = size
  currentPage.value = 1
  loadDemandHistory()
}

// 当前页改变
function handleCurrentChange(page) {
  currentPage.value = page
  loadDemandHistory()
}

// 监听stationId变化
watch(() => props.stationId, () => {
  if (props.stationId) {
    currentPage.value = 1
    loadDemandHistory()
  }
}, { immediate: true })

// onMounted(() => {
//   if (props.stationId) {
//     loadDemandHistory()
//   }
// })
</script>

<style lang="scss" scoped>
.demand-history-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .table-container {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    flex: 1;
  }

  .pagination-container {
    padding: 16px 24px;
    display: flex;
    justify-content: flex-end;
    background: #FFFFFF;
  }
}
</style> 